import React, { useState } from 'react';
import './i18n';  //// import i18n (needs to be bundled ;)) 
import { useTranslation } from 'react-i18next';

import Select from 'react-select';

export default function CriteriaDietaryTreatment({className, dietaryOptions, defaultValue, value, onChange}) {
    const { t } = useTranslation();

    const options = [
        //{value: 1, label: t('without meals, without treatment')},
        {value: 2, label: t('1 meals, without treatment')},
        {value: 3, label: t('2 meals, without treatment')},
        {value: 4, label: t('3 meals, without treatment')},
        {value: 5, label: t('without meals, with treatment')},
        {value: 6, label: t('1 meals, with treatment')},
        {value: 7, label: t('2 meals, with treatment')},
        {value: 8, label: t('3 meals, with treatment')},
    ]

    const handeChange = (selectedOption) => {
        //console.log(`CriteriaDietaryTreatment(): selectedOption:`, selectedOption);
        if (!onChange)
            return;
        onChange(selectedOption);
    }

    return (
        <div className={`dietary-treatment ${className}`}>
            <Select
                closeMenuOnSelect={true}
                isMulti={false}
                isSearchable={false}
                //menuIsOpen={true} /** for debug */
                options={dietaryOptions ?? options}
                defaultValue={defaultValue}
                value={value ?? defaultValue}
                placeholder={t('Dietary and treatment options')}
                onChange={handeChange}
            />
        </div>
    );
}
